export const TRACKING_SEARCH_URL = 'marriott.com';

export const DEFAULT_TRACKING_VALUES = {
  GLOBAL_NAV: 'Global Nav',
  LABEL_NULLISH: 'Label unknown',
};

export const CACHE_MARRIOTT_URL = 'https://cache.marriott.com';

export const HOTEL_LOGO_ALT_TEXT = 'hotel logo';
export const SHOW_BROWSER_REGISTRATION = 'show_browser_registration';
export const REMEMBER_ME_KEY = 'remember_me';

export const ACCOUNT_FLYOUT_MODAL_ID = 'global-header-sign-in';
export const ACCOUNT_MODAL_OPEN_EVENT = 'accountModalOpen';
export const ACCOUNT_MODAL_CLOSE_EVENT = 'accountModalClose';
export const SESSION_TIMED_OUT_API = '/mi/phoenix-account-auth/v1/sessionTimeOut';
export const CLOSE_DRAWER_EVENT = 'CLOSE_DRAWER';
export const TAB_DIRTY_SESSION = 'tab_dirty_session';
export const SIGN_IN_LINK_SUFFIX = '/sign-in';
